import { ActivatedRoute } from '@angular/router';

export const routeParams = (route: ActivatedRoute) => {
  const { params, queryParams } = route.snapshot;
  return { ...params, ...queryParams };
};
